//Responsive Category Component
import React from 'react';
import { connect } from 'react-redux';

import $ from 'jquery';

//For coming soon tooltip
import { Tooltip } from 'react-bootstrap';
import { OverlayTrigger } from 'react-bootstrap';

//Category images
import waste from '../../assets/icons/waste.png';
import water from '../../assets/icons/water.png';
import pothole from '../../assets/icons/pothole.png';
import air from '../../assets/icons/air.png';
import sanitation from '../../assets/icons/sanitation.png';
import education from '../../assets/icons/education.png';
import civic from '../../assets/icons/civic.png';
import governance from '../../assets/icons/governance.png';

//Category state update
import ViewSettings from '../../models/settings/index';
import GovernanceData from '../../models/data/governance/index';
import JGRICMYCSource from '../../models/source/jgrIcmyc/index'

// import AqmChart from '../d3-charts/aqm-chart';

//Tooltip for category
const tooltip = (
    <Tooltip id="tooltip">
        <strong>Coming Soon!</strong>.
    </Tooltip>
);

class CategoryPane extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activeKey: '',
            viewSettings: props.viewSettings,
            showChartContaier: false
        }
        this.viewSettingsChanged = this.viewSettingsChanged.bind(this);
        // this.invokeCompoent = this.invokeCompoent.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            viewSettings: nextProps.viewSettings
        });
    }
    handleSelect(activeKey) {
        this.setState({
            activeKey
        });
    }
    componentDidMount() {

        //Jquery fn. for menu click
        $.fn.clicktoggle = function (a, b) {
            return this.each(function () {
                var clicked = false;
                $(this).click(function () {
                    if (clicked) {
                        clicked = false;
                        return b.apply(this, arguments);
                    }
                    clicked = true;
                    return a.apply(this, arguments);
                });
            });
        };
        $(document).ready(function () {
            $(function () {
                $("#waste-icon").click(function () {
                    $("#category-data-wrapper").addClass("category-bg-color-1");
                });
            });
            $(function () {
                var getCurrentTop;
                $("#down-arrow").clicktoggle(function () {
                    //$(".inner-view-container").css({'top':'753px'});
                    $("#down-arrow").addClass("arrow-rotate");
                    getCurrentTop = $(".inner-view-container").css("top");
                    var getTopPosition = $(".inner-view-container").offset().top;
                    var getElementHeight = ($(".category-container-background-wrapper").height());
                    var getFinalTopPosition = getElementHeight + getTopPosition;
                    $(".inner-view-container").css({ 'top': getFinalTopPosition });
                },
                    function () {
                        $("#down-arrow").removeClass("arrow-rotate");
                        $(".inner-view-container").css({ 'top': getCurrentTop });
                    });
            });
        });

        //Jquery fn. to change the border color of selected category
        $('#governance').click(function () {
            $('#governance').css({
                'border-style': 'solid',
                'border-width': '4px',
                'border-color': '#0b6'
            });
            $('#waste, #pothole, #air, #sanitation').css({
                'border-style': 'solid',
                'border-width': '1px',
                'border-color': 'transparent'
            });
        });
        $('#air').click(function () {
            $('#air').css({
                'border-style': 'solid',
                'border-width': '4px',
                'border-color': '#0b6'
            });
            $('#waste, #pothole, #sanitation, #governance').css({
                'border-style': 'solid',
                'border-width': '1px',
                'border-color': 'transparent'
            });
        });
        $('#pothole').click(function () {
            $('#pothole').css({
                'border-style': 'solid',
                'border-width': '4px',
                'border-color': '#0b6'
            });
            $('#waste, #air, #governance, #sanitation').css({
                'border-style': 'solid',
                'border-width': '1px',
                'border-color': 'transparent'
            });
        });
        $('#waste').click(function () {
            $('#waste').css({
                'border-style': 'solid',
                'border-width': '4px',
                'border-color': '#0b6'
            });
            $('#pothole, #air, #governance, #sanitation').css({
                'border-style': 'solid',
                'border-width': '1px',
                'border-color': 'transparent'
            });
        });
        $('#sanitation').click(function () {
            $('#sanitation').css({
                'border-style': 'solid',
                'border-width': '4px',
                'border-color': '#0b6'
            });
            $('#pothole, #air, #governance, #waste').css({
                'border-style': 'solid',
                'border-width': '1px',
                'border-color': 'transparent'
            });
        });
    }
    componentShouldMount() {
        return ((!this.props.nearbyFeaturesAreLoading)
            && (this.props.nearbyFeaturesAreLoaded)
        );
    }

    //Changing the state of the category
    viewSettingsChanged(event) {
        let id = event.target.id;
        let viewSettings = this.state.viewSettings;
        ViewSettings.updateSettings(Object.assign({}, viewSettings, {
            [id]: (!viewSettings[id])
        }));
    }
    render() {
        return <div className="category-container home-category-container" id="category-container">
            <div className="main-category-wrapper">
                <div className="category-icons">
                    <div className="category-icon">
                        <div className="c-icon bgcolor-1">
                            <div className="c-icon-img">
                                <img src={waste} alt="dustbin icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="waste" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["waste"]} />
                                Waste
                            </p>
                        </div>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <div className="c-icon bgcolor-2">
                                <div className="c-icon-img">
                                    <a><img src={water} alt="water icon" /></a>
                                </div>
                                <p className="c-icon-title" style={{ backgroundColor: "#D3D3D3", fontSize: 15 }}>Water</p>
                            </div>
                        </OverlayTrigger>
                        <div className="c-icon bgcolor-3">
                            <div className="c-icon-img">
                                <img src={pothole} alt="pothole icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="pothole" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["pothole"]} /><span className="checkbox-material"><span className="check"></span></span>
                                Pothole
                            </p>
                        </div>
                        <div className="c-icon bgcolor-4">
                            <div className="c-icon-img">
                                <img src={air} alt="air icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="air" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["air"]} />
                                Air
                            </p>
                        </div>
                        <div className="c-icon bgcolor-5">
                            <div className="c-icon-img">
                                <img src={sanitation} alt="sanitation icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="sanitation" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["sanitation"]} />
                                Sanitation
                            </p>
                        </div>
                        {/* Coming Soon Category - Start */}
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <div className="c-icon bgcolor-6">
                                <div className="c-icon-img">
                                    <a><img src={education} alt="education icon" /></a>
                                </div>
                                <p className="c-icon-title" style={{ backgroundColor: "#D3D3D3", fontSize: 15 }}>Education</p>
                            </div>
                        </OverlayTrigger>
                        {/* <OverlayTrigger placement="top" overlay={tooltip}>
                            <div className="c-icon bgcolor-7">
                                <div className="c-icon-img">
                                    <a><img src={civic} alt="civic icon" /></a>
                                </div>
                                <p className="c-icon-title" style={{ backgroundColor: "#D3D3D3", fontSize:15 }}>Civic</p>
                            </div>
                        </OverlayTrigger> */}
                        <div className="c-icon bgcolor-7">
                            <div className="c-icon-img">
                                <img src={civic} alt="civic icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="civic" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["civic"]}
                                /> civic
                            </p>
                        </div>
                        {/* Coming Soon Category - End */}
                        <div className="c-icon bgcolor-8 c-icon-gov">
                            <div className="c-icon-img">
                                <img src={governance} alt="governance icon" />
                            </div>
                            <p className="c-icon-title" style={{ fontSize: 15 }}>
                                <input type="checkbox" id="governance" onChange={this.viewSettingsChanged} checked={this.state.viewSettings["governance"]} />
                                Governance
                            </p>
                        </div>
                    </div>
                </div>
                {/* {this.state.showChartContaier ? <AqmChart /> : null} */}
            </div>
        </div >;
    }
}
export default connect((state, ownProps) => {
    return ({
        viewSettings: state.viewSettings
    });
})(CategoryPane);


// WEBPACK FOOTER //
// ./src/components/category/category.js